import React from 'react';

interface AllocationItem {
  value: number;
  label: string;
  color: string;
}

interface AllocationBarProps {
  totalAmount: number;
  items: AllocationItem[];
  height?: number;
  borderRadius?: number;
}

const AllocationBar: React.FC<AllocationBarProps> = ({ totalAmount, items, height = 18, borderRadius = 16 }) => {
  return (
    <div className="w-full flex overflow-hidden" style={{ height, borderRadius, background: '#E9ECEF' }}>
      {items.map((item, idx) => {
        const widthPercent = totalAmount > 0 ? (item.value / totalAmount) * 100 : 0;
        return (
          <div
            key={item.label + idx}
            style={{
              width: `${widthPercent}%`,
              background: item.color,
              height: '100%',
              borderTopLeftRadius: idx === 0 ? borderRadius : 0,
              borderBottomLeftRadius: idx === 0 ? borderRadius : 0,
              borderTopRightRadius: idx === items.length - 1 ? borderRadius : 0,
              borderBottomRightRadius: idx === items.length - 1 ? borderRadius : 0,
              transition: 'width 0.3s'
            }}
          />
        );
      })}
    </div>
  );
};

export default AllocationBar;
